import { Layout } from "antd";

export function Section(props: { width?: string, height?: string, children: React.ReactNode }) {

  let { width, height } = props;
  if (width === undefined) width = "auto";
  if (height === undefined) height = "auto";

  return (
    <div className="mig-section" style={{ width: width, height: height }}>
        {props.children}
    </div>
  );
}